<template>
  <div class="container">
    <div class="image-wrapper">
      <img :src="image.url" class="image-item" alt="" ref="imageWrapper" />
      <div class="region-wrapper">
        <VueDraggableResizable
          :active="true"
          :parent="true"
          class="region-item"
          :max-width="wrapperSize.w - wrapperSize.w * defaultRegion.x"
          :max-height="wrapperSize.h - wrapperSize.h * defaultRegion.y"
          :w="wrapperSize.w * defaultRegion.w"
          :h="wrapperSize.h * defaultRegion.h"
          :x="wrapperSize.w * defaultRegion.x"
          :y="wrapperSize.h * defaultRegion.y"
          @resizestop="onResizingStop"
          @dragstop="onDragStop"
          v-if="regionShow"
        >
        </VueDraggableResizable>
      </div>
    </div>
    <el-form ref="form" :model="defaultRegion" label-width="20px" style="width: 300px">
        <el-form-item label="w">
          <el-input v-model="defaultRegion.w"></el-input>
        </el-form-item>
        <el-form-item label="h">
          <el-input v-model="defaultRegion.h"></el-input>

        </el-form-item>
        <el-form-item label="x">
          <el-input v-model="defaultRegion.x"></el-input>

        </el-form-item>
        <el-form-item label="y">
          <el-input v-model="defaultRegion.y"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="success" @click="confirmDetectedRegion">确定</el-button>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import VueDraggableResizable from "vue-draggable-resizable";
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
export default {
  name: "",
  components: {
    VueDraggableResizable
  },
  props: {
    image: {
      type: Object
    }
  },
  data() {
    return {
      regionShow: false,
      wrapperSize: {},
      defaultRegion: {
        x: 0.1,
        y: 0.1,
        w: 0.8,
        h: 0.8
      }
    };
  },
  mounted() {
    // console.log(this.$refs);
    this.computeSize();
  },
  methods: {
    ...mapActions([]),
    confirmDetectedRegion () {
      this.$emit('detectedRegion', this.defaultRegion);
    },
    onResizingStop (x, y, w, h) {
      let image = this.$refs['imageWrapper'];
      let width = image.offsetWidth;
      let height = image.offsetHeight;

      this.defaultRegion = {
        x: x / width,
        y: y / height,
        w: w / width,
        h: h / height
      };
    },
    onDragStop (x, y, index) {
      let image = this.$refs['imageWrapper'];
      let width = image.offsetWidth;
      let height = image.offsetHeight;
      console.log(height);
      this.defaultRegion.x = x / width;
      this.defaultRegion.y = y / height;
    },
    computeSize() {
      this.$nextTick(() => {
        const imageWrapper = this.$refs["imageWrapper"];
        let width = imageWrapper.clientWidth;
        let img = new Image();
        img.src = this.image.url;
        img.onload = () => {
          this.wrapperSize = {
            w: width,
            h: (width / img.width) * img.height
          };
          this.regionShow = true;
        };
      });
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  .image-wrapper {
    position: relative;
    display: inline-block;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    .image-item {
      width: 400px;
      padding: 0;
      margin: 0;
    }
    .region-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      .region-item {
        border: 2px solid #ff0000;
      }
    }
  }
}
</style>
